import * as type from './SearchType';
import * as api from './SearchApi';
import { getClinicId, getNamespace } from '../../utils/storage';
import { getOperands } from './SearchUtils';

export const addNewField = (index) => (dispatch) => {
    dispatch({
        type: type.ADD_NEW_FIELD,
        payload: index
    });
};
export const addStructure = (data) => (dispatch) => {
    dispatch({
        type: type.ADD_STRUCTURE,
        payload: data
    });
};
export const addField = (data) => (dispatch) => {
    dispatch({
        type: type.ADD_FIELD,
        payload: data
    });
};
export const deleteSelectedField = (index) => (dispatch) => {
    dispatch({
        type: type.DELETE_SELECTED_FIELD,
        payload: index
    });
};

export const addValue = (data) => (dispatch) => {
    dispatch({
        type: type.ADD_VALUE,
        payload: data
    });
};
export const addSelectValue = (data) => (dispatch) => {
    dispatch({
        type: type.ADD_SELECT_VALUE,
        payload: data
    });
};
export const deleteValue = (index) => (dispatch) => {
    dispatch({
        type: type.DELETE_VALUE,
        payload: index
    });
};

export const addErrorMessage = (data) => (dispatch) => {
    dispatch({
        type: type.ADD_ERROR_MESSAGE,
        payload: data
    });
};
export const deleteField = (index) => (dispatch) => {
    dispatch({
        type: type.DELETE_FIELD,
        payload: index
    });
};
export const resetFields = () => (dispatch) => {
    dispatch({
        type: type.RESET_FIELDS
    });
};

export const getSearch =
    (clinic, service = api.searchResult) =>
    async (dispatch, getState) => {
        const operands = getOperands(getState()?.search?.fields);
        const namespace = getNamespace();
        const body = {
            operator: 'and',
            namespace,
            operands,
            ...(clinic !== '0' && { clinic })
        };
        if (!operands?.every((item) => item.value)) {
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: `.There is no field value, please enter a value then click on search button`,
                    status: 500
                }
            });
        } else {
            dispatch({
                type: type.SEARCH_FORM_REQUEST
            });
            return await service(body)?.then((response) => {
                dispatch({
                    type: type.SEARCH_FORM_SUCCESS,
                    payload: response?.data?.results,
                    total: response?.data?.total
                });
            });
        }
    };

export const getSearchReport =
    (service = api.getSearchReport) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(namespace)?.then((response) => {
            dispatch({
                type: type.GET_SEARCH_REPORT,
                payload: response.data
            });
            return response;
        });
    };
export const createSearchReport =
    (exportConfig, fields, service = api.createSearchReport) =>
    async (dispatch) => {
        const operands = getOperands(fields);
        const namespace = getNamespace();
        const clinic = getClinicId();
        const body = {
            export_config: exportConfig,
            export_query: {
                operator: 'and',
                operands
            },
            namespace,
            clinic
        };

        return await service(body).then(() => {
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'Request to create report created',
                    status: 200
                }
            });
            // if (response.status >= 200 && response.status <= 300) {
            //     if (callback) {
            //         callback();
            //     }
            // }
        });
    };

export const deleteSearchReport =
    (exportId, service = api.deleteSearchReport) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(exportId, namespace).then(() => {
            dispatch({
                type: type.DELETE_SEARCH_REPORT,
                payload: exportId
            });
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'Report deleted successfully',
                    status: 200
                }
            });
        });
    };
